import React from 'react';
import styled from 'styled-components';
import CloseComplete from './CloseComplete';
import CloseError from './CloseError';
import CloseInComplete from './CloseInComplete';

const Close = () => {
    return (
        <WrapperWithStyled>
            <CloseInComplete />
            <CloseComplete />
            <CloseError />
        </WrapperWithStyled>
    );
};
const WrapperWithStyled = styled.div`
    margin-top: 10px;
`

export default Close;